import { FC, useContext } from 'react';
import { Box, Divider, Group, Text, useMantineTheme } from '@mantine/core';
import { IconPaperclip } from '@tabler/icons';
import { useParams } from 'react-router-dom';
import Moment from 'react-moment';
import { MessageDTO } from '../../Types/MessageT';
import { MessageS } from '../../Service/MessageS';
import { EmailBoxContext } from '../../Service/Context/EmailBoxContext';
import MessagePlaceholderText from '../../Atoms/MessagePlaceholderText';
import { ThemeText, ThemeTitle } from '../../Atoms/ThemeText';
import Dot from '../../Atoms/Dot';
import MessageOwnerInfo from './MessageOwnerInfo';

interface Props {
  email: MessageDTO;
}

const EmailRowPhone: FC<Props> = ({ email }) => {
  const { id: eventId } = useParams();
  const { readTimestamp, localDateTime, sendByUser } = email;
  const { colorScheme } = useMantineTheme();
  const { selectMessage } = useContext(EmailBoxContext);
  const unread = localDateTime && !readTimestamp && !sendByUser;

  const contact = MessageS.getCustomerContact(email);

  return (
    <>
      <Box
        pos="relative"
        my="md"
        onClick={() => selectMessage(email)}
        sx={{
          borderRadius: 10,
          height: 70,
          cursor: 'pointer',
          overflow: 'hidden',
        }}
      >
        <Group position="apart">
          <Group spacing="xs">
            {unread && <Dot withoutShadow size={8} colour="#4A90E2" />}
            <ThemeTitle lineClamp={1} size="md">
              {contact.personDescription ? contact.personDescription : contact.email}
            </ThemeTitle>
          </Group>
          <Box>
            {email.imap && (
              <Text lineClamp={1} color="dimmed" size="xs">
                {email.localDateTime && <Moment calendar={MessageS.calendarStrings}>{email.localDateTime}</Moment>}
              </Text>
            )}
            {!email.imap && (
              <>
                {!email.scheduledTime && (
                  <Text color="dimmed" size="xs" align="right">
                    {email.localDateTime && <Moment calendar={MessageS.calendarStrings}>{email.localDateTime}</Moment>}
                    {!email.localDateTime && <Moment calendar={MessageS.calendarStrings}>{email.lastModified}</Moment>}
                  </Text>
                )}
                {email.scheduledTime && (
                  <Text color="dimmed" size="xs" align="right">
                    <Moment fromNow calendar={MessageS.calendarStrings}>
                      {email.scheduledTime}
                    </Moment>
                  </Text>
                )}
              </>
            )}
          </Box>
        </Group>

        {email.subject && !email.imap && (
          <ThemeText color="white" className="overflow-ellipsis" mt={5}>
            <MessagePlaceholderText settings={eventId === undefined} email={email} value={email.subject} />
          </ThemeText>
        )}
        {email.subject && email.imap && (
          <ThemeText w="100%" lineClamp={1} mt={5}>
            {email.subject}
          </ThemeText>
        )}
        {!email.subject && (
          <Text italic color="dimmed" weight="bolder">
            Kein Betreff
          </Text>
        )}
        {((email.attachments && email.attachments.length > 0) || email.countOfAttachments > 0) && (
          <Box pos="absolute" sx={{ top: 20, right: 5 }}>
            <IconPaperclip color={colorScheme === 'light' ? 'black' : 'white'} size={12} />
          </Box>
        )}
        <MessageOwnerInfo message={email} />
      </Box>
      <Divider mt={-5} />
    </>
  );
};

export default EmailRowPhone;
